import _ from 'lodash';

import {
  ImportPaymentMethodInput,
  useImportNetSuitePaymentMethodsMutation
} from 'generated/graphql';
import {
  useCallback,
  useMemo
} from 'react';



export function useImportNetSuitePaymentMethods() {
  const [fnMutate, tuple] = useImportNetSuitePaymentMethodsMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = useCallback(
    (rows: Array<_.Dictionary<string>>) => {
      const input = rows.map((row): ImportPaymentMethodInput => ({
        netSuiteInternalId: row['Internal ID'],
        name: row['Description']
      }));

      fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
